import {
  clearSessionLastActiveAt,
  getSessionLastActiveAt,
  setSessionLastActiveAt
} from '@/common/utils/SessionTimeout';

const getStoredToken = (key) => {
  return localStorage.getItem(key) || null;
};

const getStoredExpertData = () => {
  const rawData = localStorage.getItem('data');
  if (!rawData) return {};

  try {
    return JSON.parse(rawData);
  } catch (error) {
    return {};
  }
};

const hasExpertData = (expertData = {}) => {
  return Object.keys(expertData).length > 0;
};

export const state = {
  accessToken: null,
  refreshToken: null,
  phoneAuthSession: null,
  data: null,
  lastActiveAt: null
};
export const getters = {
  getAccessToken(state) {
    state.accessToken = getStoredToken('accessToken');
    return state.accessToken;
  },
  getRefreshToken(state) {
    state.refreshToken = getStoredToken('refreshToken');
    return state.refreshToken;
  },
  getPhoneAuthSession(state) {
    state.phoneAuthSession = getStoredToken('phoneAuthSession');
    return state.phoneAuthSession;
  },
  getData(state) {
    state.data = getStoredExpertData();
    return state.data;
  },
  getLastActiveAt(state) {
    state.lastActiveAt = getSessionLastActiveAt();
    return state.lastActiveAt;
  },
  getIsAuthenticated(state, getters) {
    return Boolean(getters.getAccessToken) && hasExpertData(getters.getData);
  }
};
export const mutations = {
  setAccessToken(state, { accessToken = '' }) {
    state.accessToken = accessToken;
    localStorage.setItem('accessToken', accessToken);
  },
  setRefreshToken(state, { refreshToken = '' }) {
    state.refreshToken = refreshToken;
    localStorage.setItem('refreshToken', refreshToken);
  },
  setPhoneAuthSession(state, { phoneAuthSession = '' }) {
    state.phoneAuthSession = phoneAuthSession || null;
    if (phoneAuthSession) localStorage.setItem('phoneAuthSession', phoneAuthSession);
    else localStorage.removeItem('phoneAuthSession');
  },
  setData(state, { data = {} }) {
    state.data = data;
    localStorage.setItem('data', JSON.stringify(data));
  },
  setLastActiveAt(state, { lastActiveAt = Date.now() } = {}) {
    state.lastActiveAt = setSessionLastActiveAt(lastActiveAt);
  },
  storeLogout(state) {
    state.data = null;
    state.accessToken = null;
    state.refreshToken = null;
    state.lastActiveAt = null;
    localStorage.removeItem('deviceInfo');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('data');
    clearSessionLastActiveAt();
  }
};
export const actions = {
  signIn({ commit }, payload) {
    commit('setAccessToken', payload);
    commit('setRefreshToken', payload);
    commit('setData', payload);
    commit('setLastActiveAt');
  },
  touchSession({ commit }, payload = {}) {
    commit('setLastActiveAt', payload);
  },
  signOut({ commit }) {
    if (!confirm('로그아웃하시겠습니까?')) return false;
    commit('storeLogout');
    location.reload();
  },
  expireSession({ commit }) {
    commit('storeLogout');
  },
  forceSignOut({ commit }) {
    commit('storeLogout');
    location.reload();
  }
};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
